import Vue from 'vue'
import SvgIcon from '../../../../common-components/src/components/SvgIcon'// svg component

// register globally
Vue.component('svg-icon', SvgIcon)

const req = require.context('./svg', false, /\.svg$/)
// const req = require.context('../../../../common-components/src/assets/icons/svg', false, /\.svg$/)
/*
let svgs = []
req.keys().forEach(key => {
    let file = req(key)
    svgs = svgs.concat(file)
});
console.log(svgs)
*/
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)
